import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, take, throwError } from 'rxjs';
import { ToastService } from '@/services/toast.service';
import { AuthService } from '@/services/auth.service';

const AUTH_ENDPOINT_PATTERN = /\/v1\/auth\//;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const toastService = inject(ToastService);
    const authService = inject(AuthService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                const isAuthEndpoint = AUTH_ENDPOINT_PATTERN.test(req.url);

                if (!isAuthEndpoint) {
                    authService.sessionData.pipe(take(1)).subscribe((session) => {
                        if (session.isLoggedIn) {
                            authService.expired();
                            router.navigate(['/login']);
                        }
                    });
                }
            } else if (error.status === 403) {
                toastService.showWarnToast(
                    'Keine Berechtigung',
                    'Sie haben keine Berechtigung für diese Aktion.',
                    4000
                );
            }

            return throwError(() => error);
        })
    );
};
